import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import Box from '@mui/material/Box';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";

import Typography from "@mui/material/Typography";


export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Youtube Marketing</h3>

          <p>
            You know your business needs to invest in video to avoid being left
            behind. You may have seen the stats.
          </p>
          <ul>
            <li>
              By 2022, streaming video will be over 82% of internet traffic.{" "}
              <a
                href="https://www.cisco.com/c/en_au/solutions/service-provider/visual-networking-index-vni/index.html"
                target="_blank"
              >
                (Cisco)
              </a>
            </li>
            <li>
              73% of B2B marketers report that video helps them recover their
              investments faster.{" "}
              <a
                href="https://tubularinsights.com/b2b-marketers-video-roi/"
                target="_blank"
              >
                (Tubular Insights)
              </a>
            </li>
            <li>
              YouTube is the second biggest search engine, behind its parent
              company.{" "}
              <a
                href="https://www.searchenginejournal.com/seo-101/meet-search-engines/"
                target="_blank"
              >
                (Search Engine Jouurnal)
              </a>
            </li>
          </ul>

          <h3 className={classes.title}>Youtube SEO - is a thing!</h3>
          <p>YouTube videos dominate more and more search results:</p>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/display-youtube-services/youtube-seo1.webp"
                alt="..."
                className={imgClasses}
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/display-youtube-services/youtube-seo2.webp"
                alt="..."
                className={imgClasses}
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/display-youtube-services/youtube-seo1.webp"
                alt="..."
                className={imgClasses}
              />
              <br />
              <br />
              <br />
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            But there’s a difference between throwing videos at the wall and
            having a very specific strategy. We want you to be a subject matter
            expert with a new (and optimised) customer funnel.
          </p>

          <p>
            What does the search traffic say your audience wants to watch and
            learn? How long should the videos be and what behaviour are we
            driving? At Tribalism we research your industry, your competitors,
            your keywords. Only then can we create content that will create
            customer action.
          </p>

          <h3 className={classes.title}>
            Betfair Australia/Tribalism Case Study
          </h3>

          <p>
            <br />A recent example was the work we did at{" "}
            <a href="https://www.betfair.com.au/hub/" target="_blank">
              Betfair Australia
            </a>
            . Creating the strategy, producing the content and managing the
            talent.
          </p>

          <div align="center">
            <div 
              style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                paddingTop: '56.25%'
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/KbuTCQhbwf8"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          </div>
          <br />
          <Box sx={{fontSize: '1.188rem', color:'#555555'}}>
            <p style={{marginBottom: '0px'}}>Results of this work include:</p>
            <ul>
              <li>
                a 400% growth in YouTube views in just 12 months
              </li>
              <li>
                hundreds of new customers acquired by niching down on matched
                betting.
              </li>
            </ul>
          </Box>
          <p>
            This success can be attributed to focusing on a highly valuable
            sub-segment in their market and focusing on the right keywords.
            Consistency plays it role too.
          </p>

          <p>
            Now, let us do the same for your business. We’re video marketing
            nerds and we LOVE this stuff. Let us help you before this
            opportunity passes you in 2020 and your competitors beat you to it!
          </p>
        </GridItem>
      </GridContainer>
    </div>
  );
}
